<span title="{{ title | blah }}">
    @if(businessdomain == 'None') {
    <mat-icon style="color: transparent; vertical-align: middle; width: 8px"
        [style.font-size.px]="size">radio_button_unchecked</mat-icon>
    }
    @if(businessdomain == 'DistrictHeating') {
    <mat-icon class="hpo-icons businessdomain-icon"
        [style.font-size.px]="size"
        [style.height.px]="size"
        [style.width.px]="size">branch_heat</mat-icon>
    }
    @if(businessdomain == 'Electricity') {
    <mat-icon class="hpo-icons businessdomain-icon"
        [style.font-size.px]="size"
        [style.height.px]="size"
        [style.width.px]="size">branch_electricity</mat-icon>
    }
    @if(businessdomain == 'Telecommunications') {
    <mat-icon class="hpo-icons businessdomain-icon"
        [style.font-size.px]="size"
        [style.height.px]="size"
        [style.width.px]="size">branch_communications</mat-icon>
    }
    @if(businessdomain == 'Water') {
    <mat-icon class="hpo-icons businessdomain-icon"
        [style.font-size.px]="size"
        [style.height.px]="size"
        [style.width.px]="size">branch_water</mat-icon>
    }
    @if(businessdomain == 'DistrictCooling') {
    <mat-icon class="businessdomain-icon"
        [style.font-size.px]="size"
        [style.height.px]="size"
        [style.width.px]="size">ac_unit</mat-icon>
    }
    @if(businessdomain == 'Municipality') {
    <mat-icon class="hpo-icons businessdomain-icon"
        [style.font-size.px]="size"
        [style.height.px]="size"
        [style.width.px]="size">branch_municipality</mat-icon>
    }
</span>